import { Card } from "antd";
import { useParams, useSearchParams } from "react-router-dom";
import { FiCheck, FiInfo, FiX } from "react-icons/fi";
import { Oval } from "react-loader-spinner";

import "./style.css";
import { useEffect, useState } from "react";
import axios from "axios";
import { api } from "../../api/url";

import Button from "../../components/Button";
const AboutUs = (props) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { id, doctorid } = useParams();
  const [loading, setLoading] = useState(true);
  const [btnLoading, setBtnLoading] = useState(false);
  const [visitInfo, setVisitInfo] = useState({});
  const [totalPrice, setTotalPrice] = useState();
  const [bank, setBank] = useState(0);
  const [message, setMessage] = useState('');
  const [successType, setSuccessType] = useState(false); // success -> before 5min - after 5min



  useEffect(() => {
    GetStatus();
  }, [])

  const GetStatus = async () => {

    if (searchParams.get('status') !== 'cancel' && searchParams.get('referenceNumber')) {
      await axios({
        url: api + 'appointment/admission/responsecallback',
        method: 'post',
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
        data: {
          status: searchParams.get('status'),
          invoiceId: searchParams.get('invoiceId'),
          refrenceNumber: searchParams.get('referenceNumber'),
          trackId: searchParams.get('trackId')
        }
      }).then((res) => {
        if (res.data.successfull !== true) {
          if (res.data.validationErrors?.length > 0)
            setMessage(res.data.validationErrors[0])
          else
            setMessage(res.data.StatusMessage)
        } else {
          if (res.data.data !== true) {
            // setMessage("به دلیل تاخیرپرداخت نوبت شما لغو گردید");
            setMessage("وجه پرداختی طی 48 ساعت آتی به حساب شما عودت می گردد.");
            setSuccessType(true)
          }
        }
      }).catch((err) => {
        console.log('err', err)
      }).finally(() => {
        setLoading(false);
      })
    } else {
      setLoading(false);
      setMessage('پرداخت شما با خطا مواجه شده است. در صورتی که مبلغی از حساب شما کسر شده تا ساعاتی دیگر به حساب شما از طرف بانک عودت می گردد.')
    }
  }

  const statuses = ['cancel', 'failed', 'unknown']

  return (
    <div className="factor-container ">
      {loading ?
        <Card>
          <div className="loading-container">
            <Oval
              visible={true}
              height="35"
              width="35"
              strokeWidth={3}
              color="#1E2B3B"
              ariaLabel="oval-loading"
              secondaryColor="#ACADAD"
              wrapperStyle={{}}
              wrapperClass=""
            />
          </div>
        </Card>
        :
        <Card className="factor-card">
          {/* not succes */}
          {statuses.includes(searchParams.get('status')) &&
            <div className="failed-factor-icon">
              <FiX />
            </div>
          }

          {/* succes  but  */}
          {searchParams.get('status') === 'success' && successType === false &&
            <div className="success-factor-icon">
              <FiCheck />
            </div>
          }

          {/* succes  but */}
          {searchParams.get('status') === 'success' && successType === true &&
            <div className="warning-factor-icon">
              <FiInfo />
            </div>
          }

          {/* title */}
          {statuses.includes(searchParams.get('status')) &&
            <h4>خطا در پرداخت</h4>
          }

          {searchParams.get('status') === 'success' && successType === false &&
            <h4>پرداخت موفق</h4>
          }

          {searchParams.get('status') === 'success' && successType === true &&
            <h4>
              به دلیل تاخیرپرداخت نوبت شما لغو گردید
            </h4>
          }




          <div style={{ textAlign: 'center' }} className="visit-modal-confirm-content">
            {message}
            {/* <div className="row">
            <div className="col-lg-6 col-6 ">شناسه نوبت:</div>
            <div className="col-lg-6 col-6 visit-modal-left">
              {visitInfo?.userFullName}
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6 col-6">
              تاریخ ثبت: {visitInfo?.userNationalCode}
            </div>
            <div className="col-lg-6 col-6 visit-modal-left">
              شناسه مرجع: {localStorage.getItem("cellphone")}
            </div>
          </div>

          <Divider />
          <div className="row">
            <div className="col-lg-6  col-6">مبلغ تراکنش:</div>
            <div className="col-lg-6 col-6 visit-modal-left">
              {number_3_3(String(totalPrice))} ریال
            </div>
          </div> */}
            {/* <Divider /> */}
          </div>
          {searchParams.get('status') === 'success' && successType === false ?
            <Button
              isSubmitting={btnLoading}
              onClick={() => (window.location.href = "/profile/history")}
              className="modal-phonenumber-container-button"
            >
              نوبت‌های من
            </Button>
            :
            <Button
              isSubmitting={btnLoading}
              onClick={() => (window.location.href = "/profile/transactions")}
              className="modal-phonenumber-container-button"
            >
              صفحه تراکنش‌ها
            </Button>
          }

        </Card>
      }
    </div>
  );
};

export default AboutUs;
